import i18n from '@/utils/i18n';
import React from 'react';
import { BORDER, FONTS, TYPOGRAPHY } from '@/styles';
import { CheckInItem } from '@/contexts/check-in-context-types';
import { formatCurrency } from '@/utils/money';
import { OrderableItemListItemImage } from '@/components/orders/orderable-item-list-item-image';
import { ScannerVariantPackListItem } from '@/components/scanner-variant-pack-list-item';
import { StyleSheet, Text, View } from 'react-native';
import { useItemDisplayOptions } from '@/contexts/new-order-context';

interface Props {
  checkInItem: CheckInItem;
}

export const OrderCheckInItemContent: React.FC<Props> = ({ checkInItem }) => {
  const { hidePlaceholderImages } = useItemDisplayOptions();
  const {
    checkInItemUUID,
    currencyCode,
    manufacturerSuggestedRetailPriceInMicros,
    suggestedRetailPriceInMicros,
    title,
    variantPack,
  } = checkInItem;

  const additionalSubtitle = suggestedRetailPriceInMicros
    ? i18n.t('srp_price', {
        price: formatCurrency(suggestedRetailPriceInMicros, currencyCode),
      })
    : manufacturerSuggestedRetailPriceInMicros
      ? i18n.t('msrp_price', {
          price: formatCurrency(
            manufacturerSuggestedRetailPriceInMicros,
            currencyCode,
          ),
        })
      : undefined;

  return (
    <View style={styles.flex}>
      {variantPack ? (
        <ScannerVariantPackListItem
          additionalSubtitle={additionalSubtitle}
          option={variantPack}
        />
      ) : (
        <View style={styles.row}>
          <View style={styles.photoContainer}>
            <OrderableItemListItemImage
              alt={`image-${checkInItemUUID}`}
              hidePlaceholderImages={hidePlaceholderImages}
              imageURLs={[]}
            />
          </View>
          <View style={styles.flex}>
            <Text
              numberOfLines={2}
              style={[TYPOGRAPHY.medium, FONTS.primarySemiBold, styles.title]}
            >
              {title}
            </Text>
          </View>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  flex: {
    flex: 1,
  },
  photoContainer: {
    ...BORDER.primary,
    overflow: 'hidden',
  },
  row: {
    flexDirection: 'row',
    gap: 16,
  },
  title: {
    marginVertical: 4,
  },
});
